export default {
	errors: {
		connection: "Connection error with the server. Check your internet.",
		server: "Internal server error. Please try again later.",
		tooManyRequests: "Too many requests in a short time. Please wait a moment.",
		retry: "Try again",
		timeout: "Connection timeout. Check your internet.",
	},
};
